module.exports = __webpack_public_path__ + "images/category_lp/game_console/main-bg_ace8aabeeb7d803f505ee32c68cee626.png";